import Cookies from 'js-cookie'

const TokenKey = 'pwy-Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const AuthKey = 'Auth-Token'

export function getAuthToken() {
  return Cookies.get(AuthKey)
}

export function setAuthToken(token) {
  return Cookies.set(AuthKey, token)
}

export function removeAuthToken() {
  return Cookies.remove(AuthKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js